<div class="overlay" #panel id="eltopepanel">
  <!--  <app-buttons (save)="submit()" [buttonsWrap]="'panel2'"></app-buttons> -->
  <!-- <mat-icon (click)="save()" class="">save</mat-icon> -->
  <!--  <mat-icon (click)="destroy()" class="dismiss">close</mat-icon> -->
  <template #target></template>
</div>
